import styled from "styled-components";
import { gray20 } from "../../../config/colors";

export const InfoText = styled.div`
  margin-left: 5px;
  margin-top: 15px;
  font-size: 15px;
  white-space: pre-wrap;
  font-family: Arial, Helvetica, sans-serif;
  color: ${gray20};
`;
